import { render, staticRenderFns } from "./orderExternalSupplierSetup.vue?vue&type=template&id=4c24295f&"
import script from "./orderExternalSupplierSetup.vue?vue&type=script&lang=js&"
export * from "./orderExternalSupplierSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports